import React, { useState, useEffect } from 'react';
import { BotonOD } from '../../style/oferta-digital/common'
import localStorage from 'mobx-localstorage';

import {
    ModalContainer,
    DocumentGridStyle
} from '../../style/carga-documentos/modal'
import { Modal } from '../../style/oferta-digital/pyme/pymeForm';

const DocumentGrid = ({ documents }) => {
    // console.log("documents", documents)
    let cols = new Array(3).fill(Array())
    let rows = new Array(Math.ceil(documents.length / 2)).fill(Array())
    // console.log(rows);
    let listDocuments = Array()
    documents.map((doc) => {
        listDocuments.push(
            <div key={doc.title} className="document">
                <div className="document__img">
                    <img
                        src={doc.img.src}
                        alt={doc.img.alt}
                    />
                </div>
                <div className="document__title">
                    {doc.title}
                </div>
                <div className="document__explanation">
                    {doc.explanation}
                </div>
            </div>
        )
    })
    // console.log(listDocuments)
    let tempList = []
    let cant_in_each = Math.floor(listDocuments.length / 3);
    let o_t = (listDocuments.length % 3) + 1;
    // console.log(o_t, cant_in_each)
    let counter = cant_in_each
    let col_index = 0;
    let currentPair = []
    listDocuments.forEach((doc, i) => {
        currentPair.push(doc)
        rows[Math.floor(i / 2)] = currentPair
        if ((i + 1) % 2 == 0) { currentPair = [] }

        tempList.push(doc)
        counter--;
        if (col_index > 2) {
            cols[col_index - o_t].push(doc)
            o_t--;
        }
        if (counter == 0 && col_index <= 2) {
            cols[col_index] = tempList
            tempList = []
            counter = cant_in_each
            col_index++;
        }

    })
    // console.log(rows)


    return (
        <DocumentGridStyle>
            <div className="desktop">
                {
                    cols.map((col, i) => (
                        <div key={i} className="document__col">
                            {col}
                        </div>
                    ))
                }
            </div>
            <div className="mobile">
                {
                    rows.map((row, i) => (
                        <div key={i} className="document__col">
                            {row}
                        </div>
                    ))
                }
            </div>
        </DocumentGridStyle>
    )
}

export const StepModal = () => {
    const [show, setShow] = useState(false)
    useEffect(() => {
        if (show) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }
    },[show])

    let getWelcome = (content) => {
        let bodyClass = content.body ? content.body.class ? content.body.class : '' : ''
        return (
            <div className="modal">
                <div className='modal__content'>
                    <div className="modal__header">
                        <div className="modal__header__img">
                            <img
                                src={content.header.img.src}
                                alt={content.header.img.alt}
                            />
                        </div>
                        <div className="modal__header__text">
                            <h1>{content.header.title}</h1>
                            <p>{content.header.description}</p>
                            <span>{content.header.subDescription}</span>
                        </div>
                    </div>
                    <div className={`modal__body ${bodyClass}`}>
                        {
                            content.documents
                                ?
                                (<DocumentGrid documents={content.documents} />)
                                : null
                        }
                        {
                            content.content
                                ? <div dangerouslySetInnerHTML={{ __html: `${content.content}` }} />
                                : null
                        }
                    </div>
                </div>
                <div className="modal__footer">
                    <BotonOD onClick={() => { setShow(false) }}>
                        {content.botonCopy ? content.botonCopy : 'Entiendo'}
                    </BotonOD>
                </div>
            </div>
        )
    }

    return {
        modal(content){
            return (
                <ModalContainer display={show} >
                    <div className="container" id = "modal_container">
                        {content && content.welcome
                            ? getWelcome(content.content)
                            : content}
                    </div>
                </ModalContainer>
            )
        },
        setShowState(bool){
            setShow(bool);
        }
    }

}